<div
  class="menu"
  [attr.data-testid]="testIds.container"
  [style.max-width]="`${maxWidth()}rem`"
  [style.min-width]="minWidth() ? `${minWidth()}rem` : null"
  [style.max-height]="maxHeight()"
  [style.overflow-y]="maxHeight() ? 'auto' : null"
>
  @for (menuItemGroup of menuItemGroups(); track menuItemGroup.key; let i = $index) {
    @if (i !== 0) {
      <hr class="menu__divider" />
    }
    @for (menuItem of menuItemGroup.items; track menuItem.label) {
      <ftr-menu-item [menuItem]="menuItem" [trackClicks]="trackClicks() ?? false" (itemClicked)="itemClicked.emit()" />
    }
  }
</div>
